// extracted by mini-css-extract-plugin
module.exports = {"icon":"product-tour-styles-module--icon--35xoT"};